import { Skeleton } from "@/components/ui/skeleton";

export function AppointmentAgendaSkeleton() {
  return (
    <div aria-busy="true" aria-label="Đang tải lịch hẹn" className="flex flex-col gap-6">
      {Array.from({ length: 3 }).map((_, dayIdx) => (
        <div key={dayIdx} className="flex flex-col gap-2">
          <Skeleton className="h-5 w-48" />
          {Array.from({ length: 2 }).map((_, i) => (
            <Skeleton key={i} className="h-20 w-full rounded-lg" />
          ))}
        </div>
      ))}
    </div>
  );
}

export function AppointmentWeekSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Đang tải lịch hẹn"
      className="grid grid-cols-7 gap-2"
    >
      {Array.from({ length: 7 }).map((_, dayIdx) => (
        <div key={dayIdx} className="flex flex-col gap-2">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-16 w-full rounded-md" />
          <Skeleton className="h-16 w-full rounded-md" />
        </div>
      ))}
    </div>
  );
}
